module.exports = __webpack_public_path__ + "img/background-3.5d470349.jpg";